import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import MembersListComponent from "./components/MembersListComponent";
import { BreadCrumb } from "primereact/breadcrumb";
import MeaLink from "../../../components/MeaLink";
import { useAuthContext } from "../../../hooks/useAuthContext";

export function MembersListPage() {
  //
  const { currentMembership } = useAuthContext();
  //
  const listRef = useRef();
  //
  const breadcrum = [
    {
      label: 'Components',
      template: () => <MeaLink to={`/school/${currentMembership?.school?.id}/admin`} icon="pi pi-home" isRipple={true}>{currentMembership?.school?.name}</MeaLink>
    },
    { label: 'Membres' }
  ];

  //
  return (
    <>
      <MeaPage
        breadcrumb={<BreadCrumb model={breadcrum} />}
        title="Liste des comptes utilisateurs de l'école"
      //subtitle="Gérer l'ensemble des comptes utilisateurs de l'école"
      >
        <MembersListComponent
          ref={listRef}
          showAddButton={true}
          showFilterButton={true}
        />
      </MeaPage>
    </>
  );
};
